/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData
     */
    Token: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthDataToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersFacebookAuthDataFacebookAuthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
    };
}

